import React, { Component } from 'react';
import { Link } from "react-router-dom";

import L from 'leaflet';
import 'leaflet.markercluster';

import config from './../config';

class IslenskuKennslaKort extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/islennskukennsla_erlendis/skolar/';

		this.state = {
			mapData: []
		};
	}

	componentDidMount() {
		this.fetchData();

		this.map = L.map(this.refs.mapContainer).setView([30, 0], 2);

		/*
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(this.map);
		*/

		L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
			attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
		}).addTo(this.map);

		this.markers = L.markerClusterGroup({
			showCoverageOnHover: false,
			maxClusterRadius: 50
		});

		this.map.addLayer(this.markers);
	}

	updateMap() {
		if (this.state.mapData.length > 0) {
			this.state.mapData.forEach(function(item) {
				if (item.lat && item.lng) {
					let address = item.address.split('\r\n').join('<br/>');

					let markerOptions = {
						title: item.name
					};

					if (item.year_to && item.year_to < new Date().getFullYear()) {
						markerOptions.icon = new L.Icon({
							iconUrl: 'https://nidhoggur.rhi.hi.is/islenskukennsla-web/css/images/marker-icon-2x-grey.png',
							shadowUrl: 'https://nidhoggur.rhi.hi.is/islenskukennsla-web/css/images/marker-shadow.png',
							iconSize: [25, 41],
							iconAnchor: [12, 41],
							popupAnchor: [1, -34],
							shadowSize: [41, 41]
						});
					}

					let marker = L.marker([item.lat, item.lng], markerOptions).bindPopup(`
						<h2>${item.name}</h2>
						${address}<br/><br/>`+
						(item.email ? '<a href="mailto:'+item.email+'">Netfang</a><br/>' : '')+
						`<a href="${item.url}">Vefsíða</a>
					`);


					this.markers.addLayer(marker)
				}
			}.bind(this))
		}
	}

	fetchData(url) {
		/*
		this.setState({
			searchString: this.props.match.params.searchString
		});
		*/

		let urlParams = [];

		/*
		if (this.props.match.params.searchString) {
			urlParams.push('search='+this.props.match.params.searchString);
		}
		*/

		urlParams.push('limit=2000');

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					mapData: json.results
				}, function() {
					this.updateMap();
				}.bind(this))
			}.bind(this));

		if (this.props.onSearch) {
			//this.props.onSearch(this.props.match.params);
		}
	}

	render() {
		return (
			<div className="map-container" ref="mapContainer"></div>
		);
	}
}

export default IslenskuKennslaKort;
